import * as contextmenu from 'components/ContextMenu';
import FileBrowserActions from 'file-browser/FileBrowserActions';
import preferences from 'Preferences';
import copyToClipboard from 'util/clipboard/copyToClipboard';

import {ReactionGraphQL} from '../../graphql-fragments/chemistry/__generated/ReactionGraphQL';

export function getContextMenuOptions(reaction: ReactionGraphQL): Array<contextmenu.ContextMenuOption> {
  const entryId = reaction.entry?.__typename === 'EntryNode' ? reaction.entry.id : null;
  return [
    {
      name: 'Open parent entry',
      click: () => {
        if (entryId) {
          FileBrowserActions.openFile(entryId);
        }
      },
      hide: () => entryId == null,
    },
    {
      name: 'Copy API ID',
      click: () => {
        copyToClipboard(reaction.id, {showToastOnSuccess: true});
      },
      hide: () => !preferences.get('ENABLE_COPY_API_ID'),
    },
  ];
}

export function open(e: Event, reaction: ReactionGraphQL): void {
  contextmenu.view.open(e, getContextMenuOptions(reaction));
}
